(function () {
	'use strict';

	angular
    .module('app.setup')
    .controller('buyerMappingConfiguration', buyerMappingConfiguration);

	buyerMappingConfiguration.$inject = ['$rootScope', '$scope', '$state', '$timeout'];

	function buyerMappingConfiguration($rootScope, $scope, $state, $timeout) {
		var vm = this;
		var reportSettingsName = 'Buyer Mapping Configuration';
		var meta = {};

		vm.getMeta = getMeta;

		$scope.type = 'customer';
		$scope.reportSettingsName = reportSettingsName;
		$scope.baseReportName = reportSettingsName;

		function getMeta() {
			return meta;
		}
	}
})();